import { getCurrentInstance, shallowRef, onMounted, onUpdated, onBeforeUnmount } from "vue";
const useTemplateRef = (key) => {
  const vm = getCurrentInstance();
  const el = shallowRef();
  const updateEl = () => {
    var _a;
    el.value = (_a = vm.proxy) == null ? void 0 : _a.$refs[key];
  };
  onMounted(updateEl);
  onUpdated(updateEl);
  onBeforeUnmount(updateEl);
  return el;
};
export { useTemplateRef as u };
//# sourceMappingURL=useTemplateRef.js.map
